<div class="mb-4">
  <h4>{{ titleWrapper }}</h4>
</div>
<div>
  <ng-content select="[body]"></ng-content>
</div>
<div>
  <ng-content select="[footer]"></ng-content>
</div>
